var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"page d-flex flex-column flex-md-row",attrs:{"id":"authentication_index"}},[_c('div',{staticClass:"auth-content mx-auto pa-5 pa-md-12 d-flex flex-column justify-space-between"},[_c('OnboardingHeader'),_c('router-view'),_c('OnboardingFooter')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }